import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=6cb48723&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports